var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Marker, Popup } from "./styled/search-marker";
function getCrispPixel(size) {
    var pixelRatio = window.devicePixelRatio || 1;
    return Math.round(size * pixelRatio) / pixelRatio;
}
function createPosition(_a) {
    var lat = _a.lat, lon = _a.lon, map = _a.map;
    var _b = map.project([lon, lat]), x = _b.x, y = _b.y;
    return {
        transformWithOffset: function (component) {
            // TODO: I need to find a better way around this. This relies on defaultProps
            // TODO: and isn't very clear to the developer they can utilize the offset.
            var offsetX = get(component, "props.offsetX", 0);
            var offsetY = get(component, "props.offsetY", 0);
            var crispPixelX = getCrispPixel(x + offsetX);
            var crispPixelY = getCrispPixel(y + offsetY);
            var baseTransform = "translate(-50%, -100%)";
            var position = "translate(" + crispPixelX + "px, " + crispPixelY + "px)";
            return baseTransform + " " + position;
        },
        transformWithoutOffset: function () {
            var crispPixelX = getCrispPixel(x);
            var crispPixelY = getCrispPixel(y);
            var baseTransform = "translate(-50%, -100%)";
            var position = "translate(" + crispPixelX + "px, " + crispPixelY + "px)";
            return baseTransform + " " + position;
        }
    };
}
function SearchMarker(_a) {
    var lat = _a.lat, lon = _a.lon, map = _a.map, component = _a.component, popupComponent = _a.popupComponent, props = __rest(_a, ["lat", "lon", "map", "component", "popupComponent"]);
    var markerRef = useRef();
    var debugMarkerRef = useRef();
    var popupRef = useRef();
    var _b = useState(false), isPopupOpen = _b[0], setIsPopupOpen = _b[1];
    useEffect(function () {
        var positionHandler = function () {
            var position = createPosition({ lat: lat, lon: lon, map: map });
            var markerTransform = position.transformWithOffset(component);
            markerRef.current.style.transform = markerTransform;
            markerRef.current.style.opacity = 1;
            if (debugMarkerRef.current) {
                var debugMarkerTransform = position.transformWithoutOffset();
                debugMarkerRef.current.style.transform = debugMarkerTransform;
                debugMarkerRef.current.style.opacity = 1;
            }
            if (popupRef.current) {
                var popupTransform = position.transformWithOffset(popupComponent);
                popupRef.current.style.transform = popupTransform;
                popupRef.current.style.opacity = 1;
            }
        };
        var clickHandler = function () { return setIsPopupOpen(false); };
        positionHandler();
        map.on("click", clickHandler);
        map.on("move", positionHandler);
        return function () {
            map.on("click", clickHandler);
            map.off("move", positionHandler);
        };
    }, [map, lat, lon, component, popupComponent, isPopupOpen]);
    return (React.createElement(React.Fragment, null,
        props.debug && React.createElement(Marker, { ref: debugMarkerRef, debug: true }),
        isPopupOpen && React.createElement(Popup, { ref: popupRef }, popupComponent),
        React.createElement(Marker, { zIndex: props.zIndex, ref: markerRef, onClick: function () {
                map.fire("click");
                setIsPopupOpen(!isPopupOpen);
            } }, cloneElement(component, {
            onClick: function (event) {
                if (typeof component.props.onClick === "function") {
                    component.props.onClick({ event: event, map: map });
                }
            }
        }))));
}
SearchMarker.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    lat: PropTypes.number.isRequired,
    lon: PropTypes.number.isRequired,
    map: PropTypes.object.isRequired,
    zIndex: PropTypes.number.isRequired,
    component: PropTypes.element.isRequired,
    popupComponent: PropTypes.element,
    debug: PropTypes.bool
};
export default SearchMarker;
